module.exports = __webpack_public_path__ + "img/portrait-073.979f1e9a.jpg";